import { render, staticRenderFns } from "./QuestionPaginationComponent.vue?vue&type=template&id=14ef932c&scoped=true"
import script from "./QuestionPaginationComponent.vue?vue&type=script&lang=js"
export * from "./QuestionPaginationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef932c",
  null
  
)

export default component.exports